export default __webpack_public_path__ + "static/media/broken-heart.5051b760.png";